import { Quill } from 'react-quill';

const Delta = Quill.import('delta');
const Clipboard = Quill.import('modules/clipboard');
const CodeBlock = Quill.import('formats/code-block');

const DOM_KEY = '__ql-matcher';

// copied from quill's clipboard module
function traverse(node, elementMatchers, textMatchers) {  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new Delta());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], (delta, childNode) => {
      let childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new Delta());
  } else {
    return new Delta();
  }
};

// copied from quill's clipboard module and extended to handle removal of break at the end of the paragraph.
export class HtmlClipboard extends Clipboard {
  convert(html) {
    if (typeof html === 'string') {
      this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
      return this.convert();
    }
    const formats = this.quill.getFormat(this.quill.selection.savedRange.index);
    if (formats[CodeBlock.blotName]) {
      const text = this.container.innerText;
      this.container.innerHTML = '';
      return new Delta().insert(text, { [CodeBlock.blotName]: formats[CodeBlock.blotName] });
    }
    let [elementMatchers, textMatchers] = this.prepareMatching();
    let delta = traverse(this.container, elementMatchers, textMatchers);
    // Remove trailing newline
    // commented out this line because it was causing the delta to be incorrect and remving the break at the end of the paragraph.
    // if (super.deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
    //   delta = delta.compose(new Delta().retain(delta.length() - 1).delete(1));
    // }
    console.log('convert', this.container.innerHTML, delta);
    this.container.innerHTML = '';
    return delta;
  };
};
